import { LogoLight, LogoDark, LogoLightStill, LogoDarkStill, LogoLightIcon, LogoIconBlank } from './img/logo';
import {
  BatteryDark,
  ManDark,
  MechanicDark,
  PaintGunDark,
  PeopleDark,
  PhoneDark,
  VanDark,
  WheelDark,
  WomanDark,
  WrenchDark,
  BatteryLight,
  ManLight,
  MechanicLight,
  PaintGunLight,
  PeopleLight,
  PhoneLight,
  VanLight,
  WheelLight,
  WomanLight,
  WrenchLight,
} from './img/icons';

import AppStoreIcon from './img/app-store.svg';
import EasyIcon from './img/Easy-Icon.png';
import FastIcon from './img/Fast-Icon.png';
import FreeIcon from './img/Free-icon.png';
import GooglePlayIcon from './img/google-play.svg';
import GooglePlayBadgeIcon from './img/google-play-badge.svg';
import HeroPng from './img/hero-1.png';
import GoogleSvg from './img/google.svg';
import AppDownloadQR from './img/app-download-qr.png';
import HeroBackground from './img/hero.svg';
import JobseekerHeroBackground from './img/hero-jobseeker.svg';
import HowItWorks1 from './img/how-it-works-1.webm';
import HowItWorks5 from './img/how-it-works-5.webm';
import VisaIcon from './img/payment/visa.svg';
import MastercardIcon from './img/payment/mastercard.svg';
import DiscoverIcon from './img/payment/discover.svg';
import AmexIcon from './img/payment/amex.svg';
import JcbIcon from './img/payment/jcb.svg';
import DinersIcon from './img/payment/diners.svg';

import Placeholder6x4 from './img/placeholder/600x400.svg';

import EmployerSend from './img/employer/send.png';
import EmployerJob from './img/employer/job.png';
import EmployerPeople from './img/employer/people.png';
import EmployerNew from './img/employer/new.gif';
import EmployerRecruiter from './img/employer/recruitment.gif';
import EmployerSelf from './img/employer/self.gif';
import EmployerLanding from './img/employer/landing.jpg';
import EmployerNewBanner from './img/employer/new-banner.svg';

import ExcelsusLogo from './img/excelsus/logo.svg';

import SplashScreen1 from './img/brand/splash_screen_1.jpg';

import AppStoreQR from './img/qr/app-store-qr.svg';
import GooglePlayQR from './img/qr/google-play-qr.svg';

export {
  LogoLight,
  LogoDark,
  LogoLightStill,
  LogoDarkStill,
  LogoLightIcon,
  LogoIconBlank,
  BatteryDark,
  ManDark,
  MechanicDark,
  PaintGunDark,
  PeopleDark,
  PhoneDark,
  VanDark,
  WheelDark,
  WomanDark,
  WrenchDark,
  BatteryLight,
  ManLight,
  MechanicLight,
  PaintGunLight,
  PeopleLight,
  PhoneLight,
  VanLight,
  WheelLight,
  WomanLight,
  WrenchLight,
  AppStoreIcon,
  EasyIcon,
  FastIcon,
  FreeIcon,
  GooglePlayIcon,
  GooglePlayBadgeIcon,
  HeroPng,
  GoogleSvg,
  AppDownloadQR,
  HeroBackground,
  JobseekerHeroBackground,
  HowItWorks1,
  HowItWorks5,
  VisaIcon,
  MastercardIcon,
  DiscoverIcon,
  AmexIcon,
  JcbIcon,
  DinersIcon,
  Placeholder6x4,
  EmployerSend,
  EmployerJob,
  EmployerPeople,
  EmployerNew,
  EmployerRecruiter,
  EmployerSelf,
  SplashScreen1,
  EmployerLanding,
  EmployerNewBanner,
  ExcelsusLogo,
  AppStoreQR,
  GooglePlayQR,
};
